interface SnapshotImage {
    imageBase64?: string;
}

interface SnapshotValue {
    readingValue?: string;
    images?: SnapshotImage[];
}

interface SnapshotResultState {
    values?: {
        [taskId: string]: SnapshotValue;
    };
}

interface BuildJobDetailsUnsavedChangesSnapshotParams {
    readingDate: Date;
    comment?: string;
    resultState: SnapshotResultState;
    // Rohtext der Eingabefelder, nicht die normalisierte Form — sonst gälte
    // schon das Normalisieren als Änderung. Die Länderauswahl gehört mit hinein:
    // ein Regionswechsel ohne Textänderung ändert sehr wohl den gespeicherten Wert
    // ("0664 1234567" wird je nach Land zu +49… oder +43…).
    capturedValues?: { phone?: string; email?: string; phoneRegion?: string };
}

export const buildJobDetailsUnsavedChangesSnapshot = ({
    readingDate,
    comment,
    resultState,
    capturedValues,
}: BuildJobDetailsUnsavedChangesSnapshotParams) => ({
    readingDate: readingDate.toISOString(),
    comment: comment ?? '',
    capturedPhone: capturedValues?.phone ?? '',
    capturedPhoneRegion: capturedValues?.phoneRegion ?? '',
    capturedEmail: capturedValues?.email ?? '',
    values: Object.entries(resultState.values ?? {})
        .sort(([leftTaskId], [rightTaskId]) => leftTaskId.localeCompare(rightTaskId))
        .map(([taskId, value]) => ({
            taskId,
            readingValue: value.readingValue ?? '',
            images: (value.images ?? []).map((image) => image.imageBase64 ?? '').filter((imageBase64) => imageBase64.length > 0),
        })),
});

export type JobDetailsUnsavedChangesSnapshot = ReturnType<typeof buildJobDetailsUnsavedChangesSnapshot>;

export const resolveAcceptedJobDetailsBaselineSnapshot = ({
    submissionAccepted,
    currentSnapshot,
}: {
    submissionAccepted: boolean;
    currentSnapshot: string;
}) => {
    if (!submissionAccepted) {
        return undefined;
    }

    return currentSnapshot;
};

export const shouldGuardJobDetailsNavigation = ({
    hasUnsavedChanges,
    isInputOpen,
}: {
    hasUnsavedChanges: boolean;
    isInputOpen: boolean;
}) => hasUnsavedChanges && isInputOpen;
